"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduce;
exports.getAnnouncements = getAnnouncements;
exports.getLastSeenTimeStamp = getLastSeenTimeStamp;
exports.getLastAnnouncementSeenTimeStamp = getLastAnnouncementSeenTimeStamp;
exports.getAnnouncementFilters = getAnnouncementFilters;
exports.getUserEntitlements = getUserEntitlements;
exports.getAnnouncementChangeList = getAnnouncementChangeList;
exports.hasUnseenAnnouncements = hasUnseenAnnouncements;
exports.hasUnseenAnnouncementsPresent = hasUnseenAnnouncementsPresent;
exports.getFilteredAnnouncement = getFilteredAnnouncement;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var types = _interopRequireWildcard(require("../actions/actionTypes"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  AnnouncementsList: undefined,
  filteredAnnouncementList: [],
  lastSeenTimeStamp: 1555714260,
  lastAnnouncementSeenTimeStamp: 1555714260,
  filters: {
    "metadata": [{
      "label": "Maintenance",
      "key": "MAINTENANCE"
    }, {
      "label": "Major issue",
      "key": "MAJOR"
    }, {
      "label": "Minor issue",
      "key": "MINOR"
    }, {
      "label": "Update",
      "key": "UPDATE"
    }]
  },
  changeList: '',
  userEntitlements: []
};

function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var payload = action.payload;
  var userEntitlementsPayload = action.userEntitlementsPayload;

  switch (action.type) {
    case types.ACTIVE_IMS_ORG_CHANGED:
      return _objectSpread({}, state, {
        AnnouncementsList: undefined
      });
    //On announcements fetched

    case types.ANNOUNCEMENTS_FETCHED:
      return _objectSpread({}, state, {
        AnnouncementsList: payload
      });
    //Resetting last seen time stamp

    case types.SET_LAST_ANNOUNCEMENT_TS:
      return _objectSpread({}, state, {
        lastSeenTimeStamp: payload.lastSeenTimestamp
      });

    case types.SET_LAST_SEEN_ANNOUNCEMENT_TS:
      /*
      * lastAnnouncementSeenTimeStamp is for showing New and Earlier sections
      * as current behaviour is on opening flyout, remove the blue dot from bell icon
      * in unified-shell and tab in widget but still group the notifications into new and early
      */
      return _objectSpread({}, state, {
        lastAnnouncementSeenTimeStamp: payload
      });
    //on filtered announcement fetched

    case types.FILTERED_ANNOUNCEMENT_FETCHED:
      return _objectSpread({}, state, {
        filteredAnnouncementList: payload.filteredAnnouncement,
        changeList: payload.changeList
      });

    case types.FETCHED_USER_ENTITLEMENTS:
      return _objectSpread({}, state, {
        userEntitlements: userEntitlementsPayload
      });
    //default

    default:
      return state;
  }
}
/**
 * get parsed Announcements list content
 * @param {JSONObject} state
 */


function getAnnouncements(state) {
  return state.announcements.AnnouncementsList;
}
/**
 * get last seen time stamp value in epocseconds
 * @param {JSONObject} state
 */


function getLastSeenTimeStamp(state) {
  return state.announcements.lastSeenTimeStamp;
}

function getLastAnnouncementSeenTimeStamp(state) {
  return state.announcements.lastAnnouncementSeenTimeStamp;
}
/**
 * get  Announcements Filter list
 * @param {JSONObject} state
 */


function getAnnouncementFilters(state) {
  return state.announcements.filters;
}

function getUserEntitlements(state) {
  return state.announcements.userEntitlements;
}

function getAnnouncementChangeList(state) {
  return state.announcements.changeList;
}

function hasUnseenAnnouncements(state) {
  if (state.announcements.AnnouncementsList && state.announcements.AnnouncementsList.length > 0) {
    return state.announcements.AnnouncementsList[0].createTimeStamp > state.announcements.lastSeenTimeStamp;
  }

  return false;
}

function hasUnseenAnnouncementsPresent(state) {
  if (state.announcements.AnnouncementsList && state.announcements.AnnouncementsList.length > 0) {
    return state.announcements.AnnouncementsList[0].createTimeStamp > state.announcements.lastAnnouncementSeenTimeStamp;
  }

  return false;
}
/*returns filtered announment based on selected filters*/


function getFilteredAnnouncement(state) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'eventType';

  //when all the filters are deselected, changelist is empty
  if ((0, _isEmpty2.default)(state.announcements.changeList)) {
    return state.announcements.AnnouncementsList;
  } else {
    if (!(0, _isEmpty2.default)(state.announcements.AnnouncementsList)) {
      //filters all elements passing the criteria
      return state.announcements.AnnouncementsList.filter(function (announcement) {
        // dynamically validate all filter criteria
        return state.announcements.changeList.some(function (item) {
          return item.key === announcement[key];
        });
      });
    }
  }
}